// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1963":"7bdda72f","2278":"d1660fc5","2751":"2f9ce967","6878":"fa49a48d","7194":"202e6bb0","7759":"5e5d7055","9035":"6c95ddc5","9730":"908754c7"}[chunkId] + ".chunk.css";
};